import React, { useEffect, useState } from 'react';
import Header from '../../layouts/Header';
import { Button, Col, Dropdown, Form, Modal, Row, Spinner, InputGroup, Nav } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ReusableTable from '../../components/ReusableTable';
import axiosInstance from '../../api/axios'; import Select from "react-select";
import makeAnimated from "react-select/animated";
import PermissionSelector from '../../components/PermissionSelector';
import { useSelector } from 'react-redux';

const USER_TYPES = {
    ADMIN: 'ADMIN-USER',
    LOGISTIC: 'LOGISTIC-USER',
};

// Small accent tokens so Admin vs Logistics reads as two distinct, consistent identities
// wherever they show up (tab pill, modal header, avatar chip).
const TYPE_THEME = {
    [USER_TYPES.ADMIN]: {
        label: 'Admin',
        color: '#4F46E5',
        soft: '#EEF0FF',
        icon: 'ri-shield-user-line',
    },
    [USER_TYPES.LOGISTIC]: {
        label: 'Logistics',
        color: '#0D9488',
        soft: '#E7F7F5',
        icon: 'ri-truck-line',
    },
};

const AdminUserMgt = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    // const { email } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    const [userMgtAccess, setUserMgtAccess] = useState([]);

    // Active tab: which user type we're viewing / creating QB*u^#6Ahnrc sambit@gmail.com
    const [activeTab, setActiveTab] = useState(USER_TYPES.ADMIN);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("UserMgt:")
            );
            setUserMgtAccess(filteredAccess);
        }
    }, [access]);

    const accessToken = localStorage.getItem('authToken');
    const [searchText, setSearchText] = useState('');
    const [roles, setRoles] = useState([]);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [userInputData, setUserInputData] = useState({
        name: '',
        email: '',
        password: '',
        access: [],
        userType: USER_TYPES.ADMIN
    });
    const [selectedRole, setSelectedRole] = useState('');
    const [errors, setErrors] = useState({});
    const [dataLoading, setDataLoading] = useState(false);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [filteredData, setFilteredData] = useState([]);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [componentData, setComponentData] = useState([
        {
            category: 'Dashboard',
            components: [
                { name: 'Dashboard', actions: ['get'] },
            ]
        },
        {
            category: 'AllReports',
            components: [
                { name: 'CustomerReport', actions: ['get'] },
                { name: 'OrdersReport', actions: ['get', 'update'] },
                { name: 'MarketingReport', actions: ['get'] },
                { name: 'KioskUserReport', actions: ['get'] },
                { name: 'UserAnalyticsReport', actions: ['get'] },
                { name: 'ProductSalesReport', actions: ['get'] },
                { name: 'ItemWiseReport', actions: ['get'] },
                { name: 'AddonSalesReport', actions: ['get'] },
                { name: 'CouponsReport', actions: ['get'] },
                { name: 'ProductCostingReport', actions: ['get'] },

                { name: 'JourneyCouponReport', actions: ['get'] },
                { name: 'JourneyCouponRevenueReport', actions: ['get'] },
                { name: 'ProductAddonSales', actions: ['get'] },

                { name: 'DaySummaryReport', actions: ['get'] },
                { name: 'MonthSummaryReport', actions: ['get'] },
                { name: 'OutletStockReport', actions: ['get'] },
                { name: 'StorageLocationStockReport', actions: ['get'] },
                { name: 'RmReorderLevel', actions: ['get'] },
                { name: 'ProductOutofStockReport', actions: ['get'] },
                { name: 'RmCentralStockReport', actions: ['get'] },
                { name: 'SubscriptionPurchaseReport', actions: ['get'] },
                { name: 'SubscriptionConsumptionReport', actions: ['get'] },
                { name: 'CentralStockTransaction', actions: ['get'] },
                { name: 'OutletStockTransaction', actions: ['get'] },
                { name: 'OutletInventoryReport', actions: ['get'] },
                { name: 'StockConsumptionReport', actions: ['get'] },
                { name: 'UserCouponReport', actions: ['get'] }
            ]
        },
        {
            category: 'Admin User Mgt',
            components: [
                { name: 'UserMgt', actions: ['add', 'get', 'update', 'delete'] },
                // { name: 'Roles', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Checklist Operations',
            components: [
                { name: 'ChecklistOperations', actions: ['add', 'get', 'update', 'delete'] }
            ]
        },
        {
            category: 'Events',
            components: [
                { name: 'events', actions: ['get'] },
                { name: 'automationEvents', actions: ['add', 'get', 'delete'] },
                { name: 'pricingEvents', actions: ['add', 'get', 'delete'] },
            ]
        },
        {
            category: 'Food Delivery App',
            components: [
                { name: 'FoodDeliveryApp', actions: ['add', 'get', 'update', 'delete'] },
                // { name: 'Roles', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Material Mgt',
            components: [
                { name: 'RawMaterials', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'RmSubCategory', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'RmMainCategory', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'StorageLocation', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'Vendors', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Menu',
            components: [
                { name: 'NewArrivals', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'CreateProduct', actions: ['add'] },
                { name: 'CategoryMgt', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AddMenu', actions: ['add'] },
                { name: 'MenuCatalog', actions: ['get', 'update', 'delete'] },
                { name: 'MenuIngredients', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'MenuGroup', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'MenuPricing', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AddonGroups', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AddonAllocation', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Outlet Mgt',
            components: [
                { name: 'Outlet', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PettyCash', actions: ['add', 'get', 'update'] },
                { name: 'OutletUser', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'KioskUser', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PettyCash', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'requests Indent',
            components: [
                { name: 'FoodRequest', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'BeverageRequest', actions: ['add', 'get', 'update'] },
                { name: 'CentralRequest', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Purchase / Outwards',
            components: [
                { name: 'StockRequest', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'LocalProcurement', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PurchaseList', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PurchaseUnits', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'OutletStockTransfer', actions: ['add'] },
                { name: 'StorageLocationStTransfer', actions: ['add'] },
                { name: 'RmDamageEntries', actions: ['add'] },

            ]
        },
        {
            category: 'Support',
            components: [
                { name: 'CustomerSupportMgt', actions: ['get'] },
                { name: 'CancellationRequest', actions: ['get'] },
                { name: 'FranchiseEnquiry', actions: ['get'] },
            ]
        },
        {
            category: 'User Levels',
            components: [
                { name: 'Level', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AddLevelRewards', actions: ['add'] },
                { name: 'ViewLevelRewards', actions: ['get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Content Management',
            components: [
                { name: 'AdvertisementMgt', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PopupAdvertisement', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'PromoteProducts', actions: ['add', 'get', 'update'] },
                { name: 'NotificationScheduler', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Coupon Management',
            components: [
                { name: 'CreateCoupon', actions: ['add'] },
                { name: 'Coupons', actions: ['get', 'update', 'delete', 'add'] },
                { name: 'UserCouponAllocation', actions: ['add', 'get', 'update', 'delete'] },
                { name: 'AutoCouponAllocation', actions: ['add', 'get', 'update', 'delete'] },
            ]
        },
        {
            category: 'Subscription',
            components: [
                { name: 'CreateSubscription', actions: ['add'] },
                { name: 'Subscriptions', actions: ['get', 'update', 'delete'] },
            ]
        },
        {
            category: 'System Preference',
            components: [
                { name: 'AppVersion', actions: ['get', 'add', 'update', 'delete'] },
                { name: 'Settings', actions: ['get', 'update'] },
                { name: 'Logs', actions: ['get'] },
            ]
        },
    ]);
    const [selectedComponentData, setSelectedComponentData] = useState([]);
    const [userId, setUserId] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showEditPassword, setShowEditPassword] = useState(false);
    const animatedComponents = makeAnimated();
    const [showPermissionsModal, setShowPermissionsModal] = useState(false);
    const [modalPermissions, setModalPermissions] = useState([]);
    const [modalTitle, setModalTitle] = useState('');

    const components = componentData?.map((comp) => ({
        value: comp,
        label: comp,
    }));

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    // Function to generate a random password
    const generatePassword = () => {
        const length = 12;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
        let password = "";
        for (let i = 0; i < length; i++) {
            password += charset.charAt(Math.floor(Math.random() * charset.length));
        }
        return password;
    };

    // Function to handle password generation
    const handleGeneratePassword = () => {
        const newPassword = generatePassword();
        setUserInputData(prev => ({
            ...prev,
            password: newPassword
        }));
    };

    // Function to toggle password visibility
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    // Function to toggle edit password visibility
    const toggleEditPasswordVisibility = () => {
        setShowEditPassword(!showEditPassword);
    };

    const formatAccessPermissions = (accessData) => {
        if (!accessData || accessData.length === 0) {
            return <span className="aum-muted-text">No permissions assigned</span>;
        }

        const handleShowPermissions = (permissions, title) => {
            setModalPermissions(permissions);
            setModalTitle(title);
            setShowPermissionsModal(true);
        };

        // Count total permissions
        const countPermissions = (data) => {
            let count = 0;

            if (Array.isArray(data)) {
                data.forEach(permission => {
                    if (typeof permission === "string") {
                        count += 1;
                    } else if (typeof permission === "object" && permission.component && permission.actions) {
                        count += permission.actions.length;
                    }
                });
            }

            return count;
        };

        let permissionsArray = [];
        let totalPermissions = 0;

        if (Array.isArray(accessData)) {
            permissionsArray = accessData;
            totalPermissions = countPermissions(accessData);
        } else if (typeof accessData === "string") {
            permissionsArray = [accessData];
            totalPermissions = 1;
        } else {
            return <span>{JSON.stringify(accessData)}</span>;
        }

        return (
            <button
                type="button"
                className="aum-access-pill"
                onClick={() => handleShowPermissions(permissionsArray, "All Permissions")}
            >
                <span className="aum-access-pill-count">{totalPermissions}</span>
                <span>permission{totalPermissions !== 1 ? 's' : ''}</span>
                <i className="ri-arrow-right-s-line"></i>
            </button>
        );
    };

    const baseColumns = [
        { header: "Sr.No", accessor: "serialNumber" },
        {
            header: "User Name",
            accessor: "name",
            render: (value, row) => (
                <div className="aum-user-cell">
                    <span className="aum-avatar" style={{ background: TYPE_THEME[activeTab].soft, color: TYPE_THEME[activeTab].color }}>
                        {value?.charAt(0)?.toUpperCase() || '?'}
                    </span>
                    <span className="mb-0 fw-medium">{value}</span>
                </div>
            ),
        },
        {
            header: "Email",
            accessor: "email",
            render: (value, row) => (
                <div>
                    <span className="mb-0 aum-email-text">{value}</span>
                </div>
            ),
        },
        // Only show the Access column for Admin Users; Logistics users have no permissions
        ...(activeTab === USER_TYPES.ADMIN
            ? [{
                header: "Access",
                accessor: "access",
                render: (value, row) => formatAccessPermissions(value)
            }]
            : []),
    ];

    const columns = [
        ...baseColumns,
        ...(
            (userMgtAccess?.includes("UserMgt:update") || userMgtAccess?.includes("UserMgt:delete") || email === "contact@xpansecafe.com")
                ? [
                    {
                        header: "Actions",
                        accessor: "_actions",
                        render: (_, row) => (
                            <div className="d-flex justify-content-start gap-2">
                                {(userMgtAccess?.includes("UserMgt:update") || email === "contact@xpansecafe.com") && (
                                    <button
                                        type="button"
                                        className="aum-icon-btn aum-icon-btn-edit"
                                        onClick={() => handleEditModal(row)}
                                        title="Edit"
                                    >
                                        <i className="ri-edit-line"></i>
                                    </button>
                                )}
                                {(userMgtAccess?.includes("UserMgt:delete") || email === "contact@xpansecafe.com") && (
                                    <button
                                        type="button"
                                        className="aum-icon-btn aum-icon-btn-delete"
                                        onClick={() => handleDeleteModal(row)}
                                        title="Delete"
                                    >
                                        <i className="ri-delete-bin-line"></i>
                                    </button>
                                )}
                            </div>
                        ),
                    }
                ] : []
        )
    ];

    const handleOpenAddModal = () => {
        setUserInputData(prev => ({
            ...prev,
            userType: activeTab,
            access: []
        }));
        setOpenAddModal(true);
        handleGeneratePassword();
    };

    const handleSearchChange = (e) => {
        const searchValue = e.target.value;
        setSearchText(searchValue);

        if (searchValue.trim() === '') {
            setFilteredData(usersList);
        } else {
            const filtered = usersList.filter(user =>
                user.name.toLowerCase().includes(searchValue.toLowerCase()) ||
                user.email.toLowerCase().includes(searchValue.toLowerCase())
            );
            setFilteredData(filtered);
        }
    };

    const getRoles = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("role", { headers });

            if (response?.data?.status === true) {
                response?.data?.data?.roles.forEach((item, index) => {
                    item.serialNumber = index + 1;
                });

                setRoles(response?.data?.data?.roles);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getPaginatedData = () => {
        const startIndex = (page - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return filteredData?.slice(startIndex, endIndex);
    };

    // Accepts the userType to filter by (ADMIN-USER or LOGISTIC-USER) and sends it to the API
    const getUsersList = async (userType) => {
        setDataLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("admin-user-management", {
                headers,
                params: { userType }
            });

            if (response?.data?.status === true) {
                response?.data?.data?.dbResponse.forEach((item, index) => {
                    item.serialNumber = index + 1;
                });

                setUsersList(response?.data?.data?.dbResponse);
                setFilteredData(response?.data?.data?.dbResponse);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setDataLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserInputData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user types
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSelectChange = (selected) => {
        setSelectedComponentData(selected);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!userInputData.name.trim()) {
            newErrors.name = 'Name is required';
        }

        if (!userInputData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(userInputData.email)) {
            newErrors.email = 'Email is invalid';
        }

        if (!userInputData.password) {
            newErrors.password = 'Password is required';
        } else if (userInputData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters';
        }

        // Permissions are only required for Admin users; Logistics users have no permission set
        if (userInputData.userType === USER_TYPES.ADMIN && (!userInputData.access || userInputData.access.length === 0)) {
            newErrors.access = 'At least one permission is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsAddBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            // For Logistics users, permissions aren't applicable - send an empty array regardless of prior state
            const payload = {
                ...userInputData,
                access: userInputData.userType === USER_TYPES.ADMIN ? userInputData.access : []
            };

            const response = await axiosInstance.post('admin-user-management', payload, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getUsersList(activeTab);
                setUserInputData({
                    name: "",
                    email: "",
                    password: "",
                    access: [],
                    userType: activeTab
                });
                setOpenAddModal(false);
                setShowPassword(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                } else {
                    errorMessage = 'An error occurred while creating the user';
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsAddBtnLoading(false);
        }
    };

    const handleEditModal = (data) => {
        setOpenEditModal(true);
        setEditedData({
            _id: data?._id,
            name: data?.name,
            email: data?.email,
            password: '',
            access: data?.access,
            role: data?.role,
            userType: data?.userType || activeTab
        });
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            // Don't send password if it's empty (not changed)
            const dataToSend = { ...editedData };
            if (!dataToSend.password) {
                delete dataToSend.password;
            }
            // Permissions aren't applicable for Logistics users
            if (dataToSend.userType !== USER_TYPES.ADMIN) {
                delete dataToSend.access;
            }

            const response = await axiosInstance.put('admin-user-management', dataToSend, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getUsersList(activeTab);
                setOpenEditModal(false);
                setShowEditPassword(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                } else {
                    errorMessage = 'An error occurred while updating the user';
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleDeleteModal = (data) => {
        setOpenDeleteModal(true);
        setUserId(data?._id);
    };

    const handleSubmitDeleteUser = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const data = {
                _id: userId
            };

            const response = await axiosInstance.delete("admin-user-management", { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getUsersList(activeTab);
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response?.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            } else if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            } else {
                toast.error('An error occurred while deleting the user', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const formatPermission = (permission) => {
        if (!permission) return "";

        // 1. Remove :action part (e.g., ":get")
        let name = permission.split(":")[0];

        // 2. Insert spaces before capital letters (PascalCase or camelCase)
        name = name.replace(/([a-z])([A-Z])/g, "$1 $2");

        // 3. Capitalize first letter of each word
        name = name.replace(/\b\w/g, (char) => char.toUpperCase());

        return name;
    };

    // Switch between Admin Users / Logistics Users tabs
    const handleTabChange = (tabKey) => {
        if (tabKey === activeTab) return;
        setActiveTab(tabKey);
        setSearchText('');
        setPage(1);
    };

    useEffect(() => {
        getRoles();
    }, []);

    // Re-fetch the list whenever the active tab (user type) changes
    useEffect(() => {
        getUsersList(activeTab);
    }, [activeTab]);

    const theme = TYPE_THEME[activeTab];
    const addModalTheme = TYPE_THEME[userInputData.userType] || theme;
    const editModalTheme = TYPE_THEME[editedData.userType] || theme;

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <style>{`
                .aum-page-card {
                    background: #fff;
                    border-radius: 14px;
                    border: 1px solid #EAECF0;
                    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
                    overflow: hidden;
                }
                .aum-page-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 12px;
                    padding: 24px 24px 0 24px;
                }
                .aum-title-group {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }
                .aum-title-icon {
                    width: 42px;
                    height: 42px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #EEF0FF;
                    color: #4F46E5;
                    font-size: 20px;
                    flex-shrink: 0;
                }
                .aum-title-text h5 {
                    margin: 0;
                    font-size: 17px;
                    font-weight: 700;
                    letter-spacing: 0.01em;
                    color: #101828;
                }
                .aum-title-text p {
                    margin: 2px 0 0 0;
                    font-size: 13px;
                    color: #667085;
                }
                .aum-divider {
                    height: 1px;
                    background: #EAECF0;
                    margin: 20px 0 0 0;
                }
                .aum-toolbar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 14px;
                    padding: 18px 24px;
                }
                .aum-tabs-track {
                    position: relative;
                    display: inline-flex;
                    background: #F2F4F7;
                    border-radius: 9px;
                    padding: 4px;
                    gap: 2px;
                }
                .aum-tabs-slider {
                    position: absolute;
                    top: 4px;
                    bottom: 4px;
                    width: calc(50% - 4px);
                    border-radius: 9px;
                    transition: left 0.28s cubic-bezier(.4,0,.2,1), background 0.28s ease;
                    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.15);
                }
                .aum-tab-btn {
                    position: relative;
                    z-index: 1;
                    border: none;
                    background: transparent;
                    padding: 8px 18px;
                    border-radius: 999px;
                    font-weight: 600;
                    font-size: 13.5px;
                    color: #667085;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    transition: color 0.25s ease;
                }
                .aum-tab-btn.active {
                    color: #fff;
                }
                .aum-search-wrap {
                    position: relative;
                    min-width: 260px;
                    flex: 1;
                    max-width: 340px;
                }
                .aum-search-wrap i {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #98A2B3;
                    font-size: 16px;
                }
                .aum-search-input {
                    width: 100%;
                    padding: 9px 14px 9px 38px;
                    border: 1px solid #D0D5DD;
                    border-radius: 10px;
                    font-size: 14px;
                    outline: none;
                    transition: border-color 0.2s ease, box-shadow 0.2s ease;
                }
                .aum-search-input:focus {
                    border-color: #4F46E5;
                    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
                }
                .aum-add-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    border: none;
                    border-radius: 10px;
                    padding: 9px 16px;
                    font-weight: 600;
                    font-size: 14px;
                    color: #fff;
                    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
                    transition: filter 0.15s ease, transform 0.05s ease;
                }
                .aum-add-btn:hover { filter: brightness(0.94); }
                .aum-add-btn:active { transform: translateY(1px); }
                .aum-table-wrap {
                    padding: 0 24px 24px 24px;
                }
                .aum-user-cell {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
                .aum-avatar {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 13px;
                    font-weight: 700;
                    flex-shrink: 0;
                }
                .aum-email-text {
                    color: #475467;
                    font-size: 13.5px;
                }
                .aum-muted-text {
                    color: #98A2B3;
                    font-size: 13px;
                }
                .aum-access-pill {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    border: 1px solid #EAECF0;
                    background: #F9FAFB;
                    border-radius: 999px;
                    padding: 4px 10px 4px 4px;
                    font-size: 12.5px;
                    color: #344054;
                    cursor: pointer;
                    transition: background 0.15s ease, border-color 0.15s ease;
                }
                .aum-access-pill:hover {
                    background: #EEF0FF;
                    border-color: #C7D2FE;
                    color: #4F46E5;
                }
                .aum-access-pill-count {
                    background: #4F46E5;
                    color: #fff;
                    border-radius: 999px;
                    min-width: 20px;
                    height: 20px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    font-size: 11px;
                    padding: 0 5px;
                }
                .aum-icon-btn {
                    width: 30px;
                    height: 30px;
                    border-radius: 8px;
                    border: 1px solid transparent;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 15px;
                    background: transparent;
                    cursor: pointer;
                    transition: background 0.15s ease;
                }
                .aum-icon-btn-edit { color: #4F46E5; }
                .aum-icon-btn-edit:hover { background: #EEF0FF; }
                .aum-icon-btn-delete { color: #D92D20; }
                .aum-icon-btn-delete:hover { background: #FEF3F2; }
                .aum-modal-header {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                .aum-modal-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    flex-shrink: 0;
                }
                .aum-section-label {
                    font-size: 12px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.04em;
                    color: #98A2B3;
                    margin-bottom: 10px;
                }
                .aum-pill-btn {
                    border-radius: 8px;
                    font-weight: 600;
                    font-size: 14px;
                    padding: 8px 18px;
                }
                .aum-delete-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    background: #FEF3F2;
                    color: #D92D20;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                    margin: 0 auto 14px auto;
                }
            `}</style>
            <div className="main main-app p-3 p-lg-4">
                <div className="aum-page-card">

                    <div className="aum-page-header">
                        <div className="aum-title-group">
                            <div className="aum-title-icon">
                                <i className="ri-team-line"></i>
                            </div>
                            <div className="aum-title-text">
                                <h5>USER MANAGEMENT</h5>
                                <p>{filteredData?.length || 0} {theme.label.toLowerCase()} user{filteredData?.length === 1 ? '' : 's'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="aum-divider" />

                    <div className="aum-toolbar">
                        <div className="aum-tabs-track">
                            <span
                                className="aum-tabs-slider"
                                style={{
                                    left: activeTab === USER_TYPES.ADMIN ? 4 : 'calc(50% + 0px)',
                                    background: TYPE_THEME[activeTab].color
                                }}
                            />
                            <button
                                type="button"
                                className={`aum-tab-btn ${activeTab === USER_TYPES.ADMIN ? 'active' : ''}`}
                                onClick={() => handleTabChange(USER_TYPES.ADMIN)}
                            >
                                <i className={TYPE_THEME[USER_TYPES.ADMIN].icon}></i>
                                Admin Users
                            </button>
                            <button
                                type="button"
                                className={`aum-tab-btn ${activeTab === USER_TYPES.LOGISTIC ? 'active' : ''}`}
                                onClick={() => handleTabChange(USER_TYPES.LOGISTIC)}
                            >
                                <i className={TYPE_THEME[USER_TYPES.LOGISTIC].icon}></i>
                                Logistics Users
                            </button>
                        </div>

                        <div className="d-flex align-items-center gap-3 flex-wrap">
                            <div className="aum-search-wrap">
                                <i className="ri-search-line"></i>
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="aum-search-input"
                                    placeholder={`Search ${theme.label.toLowerCase()} users...`}
                                />
                            </div>
                            <button
                                type="button"
                                className="aum-add-btn"
                                style={{ background: theme.color }}
                                onClick={handleOpenAddModal}
                            >
                                <i className="ri-add-line"></i>
                                Add {theme.label} User
                            </button>
                        </div>
                    </div>

                    <div className="aum-table-wrap">
                        <ReusableTable
                            columns={columns}
                            data={getPaginatedData()}
                            loading={dataLoading}


                            currentPage={page}
                            totalPages={Math.max(1, Math.ceil((filteredData?.length || 0) / rowsPerPage))}
                            onPageChange={(newPage) => setPage(newPage)}
                            recordsPerPage={rowsPerPage}
                            onRecordsPerPageChange={(value) => {
                                setRowsPerPage(value);
                                setPage(1); // reset to first page when page size changes
                            }}
                        />
                    </div>

                    {openAddModal && (
                        <Modal
                            show={openAddModal}
                            onHide={() => {
                                setOpenAddModal(false);
                                setErrors({});
                                setShowPassword(false);
                            }}
                            centered
                            size="xl"
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <div className="aum-modal-header">
                                    <div className="aum-modal-icon" style={{ background: addModalTheme.soft, color: addModalTheme.color }}>
                                        <i className={addModalTheme.icon}></i>
                                    </div>
                                    <Modal.Title as="div">
                                        <div className="fw-bold">Add New {addModalTheme.label.toLowerCase()} user</div>
                                        <div className="aum-muted-text" style={{ fontSize: '13px' }}>Fill in the details below to create an account</div>
                                    </Modal.Title>
                                </div>
                            </Modal.Header>
                            <Form onSubmit={handleSubmit}>
                                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    <div className="aum-section-label">Account details</div>
                                    <Row>
                                        <Col xs={12} md={6} lg={4}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Name"
                                                    className="form-control"
                                                    name="name"
                                                    value={userInputData?.name}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.name}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.name}
                                                </Form.Control.Feedback>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Email <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Email"
                                                    className="form-control"
                                                    name="email"
                                                    value={userInputData?.email}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.email}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.email}
                                                </Form.Control.Feedback>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Password <span className="text-danger">*</span>
                                                </Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type={showPassword ? "text" : "password"}
                                                        placeholder="Password"
                                                        className="form-control"
                                                        name="password"
                                                        value={userInputData?.password}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.password}
                                                    />
                                                    <Button
                                                        variant="outline-secondary"
                                                        onClick={togglePasswordVisibility}
                                                    >
                                                        <i className={showPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                                                    </Button>
                                                    <Button
                                                        variant="outline-primary"
                                                        onClick={handleGeneratePassword}
                                                    >
                                                        Re-Generate
                                                    </Button>
                                                </InputGroup>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.password}
                                                </Form.Control.Feedback>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* Permissions only apply to Admin users - Logistics users have no permission set */}
                                    {userInputData.userType === USER_TYPES.ADMIN && (
                                        <Row>
                                            <Col xs={12}>
                                                <div className="mb-2">
                                                    <div className="aum-section-label" style={{ marginBottom: '6px' }}>Permissions</div>
                                                    <Form.Label className="fw-semibold">
                                                        Assign access <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <PermissionSelector
                                                        componentData={componentData}
                                                        selectedPermissions={userInputData?.access || []}
                                                        onPermissionChange={(permissions) =>
                                                            setUserInputData(prev => ({
                                                                ...prev,
                                                                access: permissions
                                                            }))
                                                        }
                                                    />
                                                    {errors.access && (
                                                        <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                                                            {errors.access}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    {userInputData.userType === USER_TYPES.LOGISTIC && (
                                        <div className="aum-muted-text" style={{ fontSize: '13px', marginTop: '4px' }}>
                                            <i className="ri-information-line me-1"></i>
                                            Logistics users don't have module permissions to assign.
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer className="d-flex flex-wrap justify-content-between">
                                    <Button
                                        variant="outline-secondary"
                                        className="aum-pill-btn"
                                        onClick={() => {
                                            setOpenAddModal(false);
                                            setShowPassword(false);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        disabled={isAddBtnLoading}
                                        className="aum-pill-btn d-flex align-items-center"
                                        style={{ background: addModalTheme.color, borderColor: addModalTheme.color }}
                                    >
                                        {isAddBtnLoading ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Adding...
                                            </>
                                        ) : "Add user"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openEditModal && (
                        <Modal
                            show={openEditModal}
                            onHide={() => {
                                setOpenEditModal(false);
                                setShowEditPassword(false);
                            }}
                            centered
                            size="xl"
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <div className="aum-modal-header">
                                    <div className="aum-modal-icon" style={{ background: editModalTheme.soft, color: editModalTheme.color }}>
                                        <i className={editModalTheme.icon}></i>
                                    </div>
                                    <Modal.Title as="div">
                                        <div className="fw-bold">Update user details</div>
                                        <div className="aum-muted-text" style={{ fontSize: '13px' }}>{editedData?.email}</div>
                                    </Modal.Title>
                                </div>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    <div className="aum-section-label">Account details</div>
                                    <Row>
                                        <Col xs={12} md={6} lg={6}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Name"
                                                    className="form-control"
                                                    name="name"
                                                    value={editedData?.name}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={6}>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Email <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Email"
                                                    className="form-control"
                                                    name="email"
                                                    value={editedData?.email}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* Permissions only apply to Admin users - Logistics users have no permission set */}
                                    {editedData.userType === USER_TYPES.ADMIN && (
                                        <Row>
                                            <Col xs={12}>
                                                <div className="mb-2">
                                                    <div className="aum-section-label" style={{ marginBottom: '6px' }}>Permissions</div>
                                                    <Form.Label className="fw-semibold">
                                                        Assign access <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <PermissionSelector
                                                        componentData={componentData}
                                                        selectedPermissions={editedData.access || []}
                                                        onPermissionChange={(permissions) =>
                                                            setEditedData(prev => ({
                                                                ...prev,
                                                                access: permissions
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    {editedData.userType === USER_TYPES.LOGISTIC && (
                                        <div className="aum-muted-text" style={{ fontSize: '13px', marginTop: '4px' }}>
                                            <i className="ri-information-line me-1"></i>
                                            Logistics users don't have module permissions to assign.
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer className="d-flex flex-wrap justify-content-between">
                                    <Button
                                        variant="outline-secondary"
                                        className="aum-pill-btn"
                                        onClick={() => {
                                            setOpenEditModal(false);
                                            setShowEditPassword(false);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        disabled={isEditBtnLoading}
                                        className="aum-pill-btn d-flex align-items-center"
                                        style={{ background: editModalTheme.color, borderColor: editModalTheme.color }}
                                    >
                                        {isEditBtnLoading ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Updating...
                                            </>
                                        ) : "Update user"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openDeleteModal && (
                        <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
                            <Modal.Header closeButton></Modal.Header>
                            <Modal.Body className="text-center pt-0">
                                <div className="aum-delete-icon">
                                    <i className="ri-error-warning-line"></i>
                                </div>
                                <h6 className="fw-bold mb-2">Delete this user?</h6>
                                <p className="aum-muted-text mb-0">
                                    This will permanently remove their access. This action cannot be undone.
                                </p>
                            </Modal.Body>
                            <Modal.Footer className="justify-content-center border-0 pt-0">
                                <Button variant="outline-secondary" className="aum-pill-btn" onClick={() => setOpenDeleteModal(false)}>
                                    Cancel
                                </Button>
                                <Button variant="danger" className="aum-pill-btn" onClick={handleSubmitDeleteUser}>
                                    {isDeleteBtnLoading ? (
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    ) : "Delete user"}
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                    {showPermissionsModal && (
                        <Modal
                            show={showPermissionsModal}
                            onHide={() => setShowPermissionsModal(false)}
                            centered
                            size="lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>{modalTitle}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {(() => {
                                    // Categorize permissions for modal display
                                    const categorizeForModal = (permissions) => {
                                        const categorized = {
                                            get: [],
                                            add: [],
                                            update: [],
                                            delete: [],
                                            other: [],
                                        };

                                        permissions?.forEach((permission) => {
                                            if (typeof permission === "string") {
                                                const [resource, action] = permission.split(":");
                                                const actionType = action?.toLowerCase();

                                                if (["get", "view", "read"].includes(actionType)) {
                                                    categorized.get.push(`${resource}:${action}`);
                                                } else if (["add", "create"].includes(actionType)) {
                                                    categorized.add.push(`${resource}:${action}`);
                                                } else if (["update", "edit", "modify"].includes(actionType)) {
                                                    categorized.update.push(`${resource}:${action}`);
                                                } else if (["delete", "remove"].includes(actionType)) {
                                                    categorized.delete.push(`${resource}:${action}`);
                                                } else {
                                                    categorized.other.push(`${resource}:${action}`);
                                                }
                                            } else if (typeof permission === "object" && permission.component) {
                                                if (permission.actions && Array.isArray(permission.actions)) {
                                                    permission.actions.forEach((action) => {
                                                        const actionType = action.toLowerCase();
                                                        if (["get", "view", "read"].includes(actionType)) {
                                                            categorized.get.push(`${permission.component}:${action}`);
                                                        } else if (["add", "create"].includes(actionType)) {
                                                            categorized.add.push(`${permission.component}:${action}`);
                                                        } else if (["update", "edit", "modify"].includes(actionType)) {
                                                            categorized.update.push(`${permission.component}:${action}`);
                                                        } else if (["delete", "remove"].includes(actionType)) {
                                                            categorized.delete.push(`${permission.component}:${action}`);
                                                        } else {
                                                            categorized.other.push(`${permission.component}:${action}`);
                                                        }
                                                    });
                                                }
                                            }
                                        });

                                        // Remove duplicates and sort
                                        Object.keys(categorized).forEach((key) => {
                                            categorized[key] = [...new Set(categorized[key])].sort();
                                        });

                                        return categorized;
                                    };

                                    const categorized = categorizeForModal(modalPermissions);
                                    const actionLabels = {
                                        get: "View Access",
                                        add: "Create Access",
                                        update: "Edit Access",
                                        delete: "Delete Access",
                                        other: "Other Permissions",
                                    };

                                    // Map action type to badge colors
                                    const badgeColors = {
                                        get: "success",   // green
                                        add: "warning",   // yellow
                                        update: "primary", // blue
                                        delete: "danger", // red
                                        other: "secondary", // gray
                                    };

                                    return (
                                        <div className="permission-categories-modal">
                                            {Object.entries(categorized).map(([actionType, permissions]) => {
                                                if (permissions.length === 0) return null;

                                                return (
                                                    <div key={actionType} className="mb-3">
                                                        <h6 className="fw-semibold text-muted mb-2">
                                                            {actionLabels[actionType]} ({permissions?.length})
                                                        </h6>
                                                        <div className="d-flex flex-wrap gap-1 ms-2">
                                                            {permissions?.map((permission, index) => (
                                                                <span
                                                                    key={index}
                                                                    style={{ fontSize: '13px' }}
                                                                    className={`badge bg-${badgeColors[actionType]} mb-1`}
                                                                >
                                                                    {formatPermission(permission)}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                })()}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={() => setShowPermissionsModal(false)}
                                >
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                </div>
            </div>
        </React.Fragment>
    );
};

export default AdminUserMgt;